import { DATE_FORMAT, DATE_TIME_FORMAT, DEFAULT_SCENARIOS, MAX_SCENARIOS, MOMENT_FORMAT, SENSOR_STATUS_ABNORMAL, SENSOR_STATUS_ALERT, SENSOR_STATUS_GATE_CLOSED, SENSOR_STATUS_GATE_OPENED } from 'constants/config';
import moment from 'moment';
import { SENSOR_PROPERTIES, UNDEFINED_TEXT } from './constanst';
import { uploadData, getUrl } from 'aws-amplify/storage';

export const convertDateFormat = (datetime) => {
  const temp = moment(datetime);
  if (temp.isValid()) return temp.format(DATE_FORMAT);
  return "";
}

export const convertDateTimeFormat = (datetime) => {
  const temp = moment(datetime);
  if (temp.isValid()) return temp.format(DATE_TIME_FORMAT);
  return "";
}

export const convertMomentFormat = (datetime) => {
  const temp = moment(datetime);
  if (temp.isValid()) return temp.format(MOMENT_FORMAT);
  return "";
}

export const convertMomentToFileName = (datetime) => {
  const temp = moment(datetime);
  if (temp.isValid()) return temp.format(MOMENT_FORMAT).replace(/\/|\s/g, '-').replace(/:/g, '')
  return "";
}


export const checkEmail = (email) => {
  const regex = /^\w+([\.\+-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

  return regex.test(email.toLowerCase());
};

/**
 * convert fullwidth english ( some common roman characters ) to halfwidth
 * @param {string} s 
 */
const convertFullWidthEnglishToHalfWidth = (s) => {
  let result = "";
  let code = 0;
  let delta = 0xFF01 - 0x0021;
  if (s) {
    for (let i = 0; i < s.length; i++) {
      code = s.charCodeAt(i);
      if (0xFF01 <= code && code < 0xFF5F) {
        result += String.fromCharCode(code - delta);
      }
      else {
        result += s.charAt(i);
      }
    }
  }
  return result;
}

/**
 * replace all chars in s that exists in sourceTemplate by equivalent chars in targetTemplate
 * ex: s = "ABCEDFG", targetTemplate = "AC", targetTemplate = "13"
 * replace A with 1, C with 3 then return : "1B3DEFG"
 * @param {string} s 
 * @param {string} sourceTemplate 
 * @param {string} targetTemplate 
 */
const convertStringByTemplate = (s, sourceTemplate, targetTemplate) => {
  let result = "";
  for (let i = 0; i < s.length; i++) {
    let index = sourceTemplate.indexOf(s[i]);
    if (index >= 0) {
      result += targetTemplate[index];
    }
    else {
      result += s[i];
    }
  }
  return result;
}


/**
 * convert full will to halfwidth
 * @param {string} s 
 */
const convertFullWidthKatakataToHalfWidth = (s) => {
  const fullwidth = "。「」、・ヲァィゥェォャュョッーアイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワン゛゜"
  const halfwidth = "｡｢｣､･ｦｧｨｩｪｫｬｭｮｯｰｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝﾞﾟ";
  return convertStringByTemplate(s, fullwidth, halfwidth);
}

/**
 * convert small katakana to large katakaba 
 * @param {string} s 
 */
const convertSmallKatakanaToLargeKatakana = (s) => {
  const smallKatakana = "ｧｨｩｪｫｬｭｮｯ";
  const largeKatakana = "ｱｲｳｴｵﾔﾕﾖﾂ"
  return convertStringByTemplate(s, smallKatakana, largeKatakana);
}

/**
 * convert fullwill to halfwidth, lower case, replace tab with 4 spaces
 * @param {string} s 
 */
export const standardizeString = (s) => {
  let result = convertFullWidthEnglishToHalfWidth(s);
  result = convertFullWidthKatakataToHalfWidth(result);
  result = convertSmallKatakanaToLargeKatakana(result);
  result = result.toLowerCase();
  return result;
}

/**
 * modified the value to correct the format
 * @param {any} value
 * @param {string} id
 */
export const modifiedValue = (value, id) => {
  if (id === SENSOR_PROPERTIES.CREATEDAT) {
    return value ? value.split(' ')[0] : UNDEFINED_TEXT;
  }
  if (typeof value === 'string') {
    if (id === SENSOR_PROPERTIES.ID) {
      return value.split('+')[0];
    }
    return value.trim() ? value : UNDEFINED_TEXT;
  } else if (typeof value === 'number') {
    return value.toFixed(3);
  } else if (typeof value === 'undefined') {
    return UNDEFINED_TEXT;
  }
}

const descendingComparator = (a, b, orderBy) => {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

export const getComparator = (order, orderBy) => {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

export const stableSort = (array, comparator) => {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

// useReducer for sensorList
export const reducer = (state, action) => {
  const { sensor, list, type } = action;

  switch (type) {
    case 'init':
      return list;
    case 'delete':
      const deleteIndex = state.findIndex(item => item.id === sensor.id);
      if (deleteIndex < 0) return state;
      const newState = [...state];
      newState.splice(deleteIndex, 1);
      return newState;
    case 'add':
      return [...state, sensor];
    case 'update':
      const updateIndex = state.findIndex(item => item.id === sensor.id);
      if (updateIndex < 0) return state;
      const updateState = [...state];
      updateState.splice(updateIndex, 1, sensor);
      return updateState;
    default:
      return state;
  }
}


//convert hex to rgba 
const isValidHex = (hex) => /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex)

const getChunksFromString = (st, chunkSize) => st.match(new RegExp(`.{${chunkSize}}`, "g"))

const convertHexUnitTo256 = (hexStr) => parseInt(hexStr.repeat(2 / hexStr.length), 16)

export const hexToRGB = (hex) => {
  if (!isValidHex(hex)) { throw new Error("Invalid HEX") }
  const chunkSize = Math.floor((hex.length - 1) / 3);
  const hexArr = getChunksFromString(hex.slice(1), chunkSize);
  const [r, g, b, a] = hexArr.map(convertHexUnitTo256);
  return (r + g + b);
}

export const addCommasToNumber = (num) => {
  return num ? num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
}

// sort file by file names
function extractDateTime(fileName) {
  // camera/past-floods+camera+c0dcd662-0d21-4ecd-bb29-50fd49fea457/1_2024-11-01T01:51:29.591Z_2024-11-01-081512.jpg
  const regex = /_(\d{4}-\d{2}-\d{2}-\d{6})\.\w+$/;
  const match = fileName.match(regex);
  return match ? match[1] : null;
}

export const sortFileByName = (files) => {
  return files.sort((a, b) => {
    const dateA = moment(extractDateTime(a.key), 'YYYY-MM-DD-HHmmss');
    const dateB = moment(extractDateTime(b.key), 'YYYY-MM-DD-HHmmss');
    return dateA - dateB
  })
}

export const truncateToThreeDecimals = (num) => {
  return Math.floor(num * 1000) / 1000;
};

export async function uploadFileToS3(fileData, key) {
  try {
    const result = await uploadData({
      key: key, // The path/name of the file in S3 (e.g., 'images/profile.jpg')
      data: fileData, // The actual data to upload (File, Blob, ArrayBuffer, etc.)
      options: {
        accessLevel: 'public', // 'guest', 'protected', or 'private'
        // Optional: Can be used to set the file type (e.g., 'image/jpeg')
        contentType: fileData.type, 
        
        // Optional: Progress tracking function
        // onProgress: ({ transferredBytes, totalBytes }) => {
        //   console.log(`Upload progress: ${Math.round((transferredBytes / totalBytes) * 100)}%`);
        // },
      },
    }).result;
    
    console.log('S3 Upload Successful. Key:', result.key);
    return result.key;
  } catch (error) {
    console.error('Error uploading file:', error);
  }
}

export async function downloadFileFromS3(key, output='text') {
  // ouput = text | arrayBuffer | blob
  try {
    const { url } = await getUrl({ key });
    const response = await fetch(url.toString(), { cache: 'no-store' });
    if (output === 'arrayBuffer') return await response.arrayBuffer()
    if (output === 'blob') return await response.blob()
    return await response.json();
  } catch (error) {
    console.error('Error downloading file:', error);
    throw error;
  }
}

export const getMaxScenarioCount = (typeCamera) => {
  if (typeCamera === 'TWIN') return MAX_SCENARIOS;
  return DEFAULT_SCENARIOS;
}